<style lang="scss">
  @import '../resources/scss/subscribe_newsletter.scss';
</style>

<script lang="ts">
  import { onDestroy } from 'svelte'
  import { locale } from 'svelte-i18n'
  import type NewsletterSection from '../api/rest/directus-cms/app/models/NewsletterSection'
  import { commonWebsiteData } from '../stores/stores'

  let lang = $locale ?? String(process.env.LOCALE)

  const unsubscribeLocale = locale.subscribe(() => {
    lang = $locale!
  })

  let newsletterSectionData: NewsletterSection
  let name = ''
  let email = ''

  const unsubscribeWebsiteData = commonWebsiteData.subscribe(data => {
    if (data?.newsletter_section) newsletterSectionData = data.newsletter_section
  })

  onDestroy(() => {
    unsubscribeWebsiteData()
    unsubscribeLocale()
  })
</script>

{#if newsletterSectionData}
  <form action="#" class="needs-validation" novalidate>
    <div class="container-fluid bg-gray">
      <div class="container-xxl py-5 d-flex justify-content-center">
        <div class="col-12 text-center">
          <div
            class="d-block d-sm-flex justify-content-center justify-sm-content-between"
          >
            <h3 class="mb-2 mb-sm-0 me-0 me-sm-4 align-self-center text-sm-start">
              {newsletterSectionData.title}
            </h3>
            <a
              role="button"
              href={newsletterSectionData.button_link}
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-grey btn-lg button px-5 py-3 h-100 align-self-center"
              >{newsletterSectionData.button_label}</a
            >
          </div>
        </div>
      </div>
    </div>
  </form>
{/if}
